import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label, FormFeedback } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-hot-toast";
import Select from "react-select";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import request from "~/utils/request";
import PriceInput from "~/components/PriceInput";

const EditPajak = ({ layer, detailInfo }) => {
  const { handleSubmit, errors, control, setValue } = useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmitPajak = (values) => {
    const isWajibPajakNIK = values.is_wajib_pajak.value;

    const newDaftarPemilik = detailInfo?.daftar_pemilik?.map((pemilik) => {
      if (pemilik.nik === isWajibPajakNIK) {
        return { ...pemilik, is_wajib_pajak: true };
      }

      return { ...pemilik, is_wajib_pajak: false };
    });

    const datas = {
      daftar_pemilik: newDaftarPemilik,
      nop: values.nop.replaceAll(".", ""),
      pbb: parseInt(values.pbb.replaceAll("Rp", "").replaceAll(",", "")),
    };

    setLoading(true);

    request
      .patch(`/v1/sig/${layer?.feature?.properties?.id}/`, datas)
      .then(() =>
        toast.success(
          `Pajak bidang NBT ${layer?.feature?.properties?.properties?.nama} berhasil diperbaharui !`
        )
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (detailInfo) {
      const findPemilikWajibPajak = detailInfo?.daftar_pemilik?.find(
        (pemilik) => pemilik.is_wajib_pajak
      );

      if (typeof findPemilikWajibPajak !== "undefined") {
        setValue("is_wajib_pajak", {
          label: findPemilikWajibPajak?.nik,
          value: findPemilikWajibPajak?.nik,
        });
      }

      setValue("nop", detailInfo?.nop);
      setValue("pbb", detailInfo?.pbb);
    }
  }, [detailInfo]);

  return (
    <div className="pl-2">
      {detailInfo?.daftar_pemilik?.length > 0 ? (
        <Form onSubmit={handleSubmit(handleSubmitPajak)}>
          <FormGroup>
            <Label>Wajib Pajak</Label>
            <Controller
              name="is_wajib_pajak"
              defaultValue=""
              control={control}
              rules={{ required: true }}
              render={({ onChange, value }) => (
                <Select
                  value={value}
                  placeholder="Pilih pemilik"
                  onChange={(val) => onChange(val)}
                  options={detailInfo?.daftar_pemilik?.map((pemilik) => ({
                    label: `${pemilik.nama?.toUpperCase()} - ${pemilik.nik}`,
                    value: pemilik.nik,
                  }))}
                />
              )}
            />

            {errors?.is_wajib_pajak && (
              <FormFeedback className="d-block">
                Harap masukkan nop
              </FormFeedback>
            )}
          </FormGroup>

          <FormGroup>
            <Label>NOP</Label>

            <Controller
              name="nop"
              control={control}
              rules={{ required: true }}
              render={({ onChange, value }) => (
                <InputMask
                  value={value}
                  className="form-control"
                  mask="99.99.999.999.999.9999.9"
                  onChange={(val) => onChange(val)}
                />
              )}
            />

            {errors?.nop && (
              <FormFeedback className="d-block">
                Harap masukkan nop
              </FormFeedback>
            )}
          </FormGroup>

          <FormGroup>
            <Label>PBB</Label>
            <Controller
              name="pbb"
              defaultValue="0"
              control={control}
              render={({ onChange, value }) => (
                <PriceInput
                  prefix="Rp. "
                  className="form-control"
                  placeholder="Rp. 1.000.000"
                  value={value}
                  onChange={(val) => onChange(val)}
                />
              )}
            />
            {errors?.pbb && <FormFeedback>Harap masukkan pbb</FormFeedback>}
          </FormGroup>

          <div
            className="simpanPerubahan"
            style={{ position: "absolute", left: 0, right: 0, bottom: -55 }}
          >
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{
                textTransform: "uppercase",
                position: "absolute",
                left: "0",
                right: 0,
                bottom: "0",
                display: "block",
                width: "100%",
                height: "50px",
                fontSize: "1rem",
              }}
            >
              {loading ? "menyimpan data..." : "Simpan"}
            </button>
          </div>
        </Form>
      ) : (
        <div>
          <i className="mdi mdi-information-outline mr-1" /> bidang ini tidak
          berpemilik, silakan isi kepemilikan terlebih dahulu.
        </div>
      )}
    </div>
  );
};

EditPajak.propTypes = {
  layer: PropTypes.object,
  detailInfo: PropTypes.object,
};

export default EditPajak;
